<nb-layout>
	<nb-layout-header fixed>
		<div class="toolbar" role="banner">
			<img width="220" alt="Angular Logo"	[src]="logo" />
			<div class="spacer"></div>
		</div>
	</nb-layout-header>

	<nb-layout-column>

		<div class="content" role="main">
			<div class="container">
				<nb-card class="card">
					<nb-card-header class="card-header">Subida completada</nb-card-header>
					<nb-card-body class="card-body">
						<div class="paragraph">
							<nb-icon icon="done-all-outline" class="card-p-icon"></nb-icon>
							<p class="card-p-text" [innerHTML]="messages.CompletedMessage ? messages.CompletedMessage : 'Su respuesta al cuestionario ha sido recibida satisfactoriamente.'"></p>
						</div>
						<div class="tracking-code-box" *ngIf="trackingCode">
							<p class="tracking-label">Guarda tu número de seguimiento:</p>
							<div class="tracking-code-row">
								<span class="tracking-code">{{ trackingCode }}</span>
								<button nbButton ghost size="small" (click)="copyTrackingCode()" class="copy-btn">
									<nb-icon [icon]="'copy-outline'"></nb-icon>
								</button>
								<button nbButton ghost size="small" (click)="downloadTrackingCode()" class="download-btn">
									<nb-icon [icon]="'download-outline'"></nb-icon>
								</button>
							</div>
							<p class="tracking-warning">{{ TRACKING_WARNING }}</p>
						</div>
					</nb-card-body>
					<nb-card-footer class="card-footer">
						<div class="footer-paragraph">
							<nb-icon icon="alert-triangle-outline" class="card-f-icon"></nb-icon>
							<p class="card-f-text" [innerHTML]="messages.CompletedInfo ? messages.CompletedInfo : 'Deberá esperar un plazo mínimo de 24 horas para responder de nuevo al mismo formulario.'"></p>
						</div>
					</nb-card-footer>
				</nb-card>
			</div>
		</div>

	</nb-layout-column>

</nb-layout>